module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av254-f1bdf0d77c73c7939e04e6c9978838f2.jpg";